import React,{useState,useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import ModalHead from './ModalHead';
import Toast from './Toast';
import Ajax from './Ajax';
//import {Inc,Girl} from "./Inc";
import {Styles} from './Styles';
import Loading from './Loading';

interface Props {
    userId:string,
    start(uid:string):void,
    close():void,
}

interface State {
    name:string,
    hobby:string,
    age:number,
    height:number,
    profile:string,
}

let isLoading = true;

const Create = (props:Props)=> {
    Ajax.setUserId(props.userId)
    const classes = Styles.base();
    const [toast,setToast] = useState("");
	const [states,setStates] = useState({
        id: 0,
		name:"",
        hobby:"",
        age:"",
        height:"",
        profile:"",
        phase:"edit",
    });
    const defErrors = {
		name:"",
        hobby:"",
        age:"",
        height:"",
        profile:"",
    };
	const [errors,setErrors] = useState(defErrors);
	const closeToast = ()=>{
        setToast("");
	}    
	const handleChange = (name: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
        let v = event.target.value.trim();
        if( name==="age" || name==="height" ){
            const num = parseInt(v);
            if( num ){
                setStates({ ...states, "id":0, [name]: parseInt(v) });
            }
        } else {
            setStates({ ...states, "id":0, [name]: v });
        }
		
    };
    const auto = ()=>{
        Ajax.send("girl/auto",{},(res:any)=>{
            if( res.ok ){
                setStates(res.girl);
            }
        })
    }
    const send = ()=>{
        if( states.id===0 ){
            //console.log("new_girl",states);
            Ajax.send("girl/new",{girl:states},(res:any)=>{
                if( res.ok ){
                    props.start(res.user_id);
                }
            })
        } else {
            props.start(props.userId);
        }
    }
    const edit = ()=>{
        setStates({...states,"phase":"input"});
    }
    const validate = ()=>{
        let err = defErrors;
        let num = 0;
        if( states.name==="" ){
            err.name = "省略しちゃダメです";
            num++;
        } else if( !isZenKatakana( states.name ) ){
            err.name = "全角カタカナと長音以外使っちゃダメです";
            num++;
        } else if( states.name.length>3 ){
            err.name = "長すぎます";
            num++;
        }
        if( states.hobby==="" ){
            err.hobby = "省略しちゃダメです";
            num++;
        } else if( states.hobby.length>12 ){
            err.hobby = "長すぎます";
            num++;
        }
        if( states.age==="" ){
            err.age = "省略しちゃダメです";
            num++;
        } else if( parseInt(states.age)<15 || parseInt(states.age)>25 ){
            err.age = "その年齢はダメです";
            num++;
        }
        if( states.height==="" ){
            err.height = "省略しちゃダメです";
            num++;
        } else if( parseInt(states.height)<140 || parseInt(states.height)>180 ){
            err.height = "その身長はダメです";
            num++;
        }
        if( states.profile==="" ){
            err.profile = "省略しちゃダメです";
            num++;
        } else if( states.profile.length>60 ){
            err.profile = "長すぎます";
            num++;
        }

        if( num>0 ){
            setErrors(err);
            setToast("困りました");
        } else {
            send();
        }
    }
    const isZenKatakana = (str:string)=>{
        str = (str==null)?"":str;
        if(str.match(/^[ァ-ヶー]*$/)){
            return true;
        }else{
            return false;
        }
    }

    useEffect( ()=>{
        if( props.userId!=="" ){
            Ajax.send("girl/get",{},(res:any)=>{
                isLoading = false;
                //console.log(res);
                if( res.ok ){
                    setStates({...res.girl,"phase":"see"});
                } else {
                    setToast("キャラクターを作成しましょう");
                }
            });
        } else {
            setToast("キャラクターを作成しましょう");
        }
    },[]);

    if( props.userId==="" ){
        isLoading = false;
    }


    if( states.phase==="see" ){
        return (
            <div id="confirm" className={classes.modalRoot}>
                <ModalHead close={props.close}/>
                <Typography variant="subtitle1" className={classes.subtitle1}>現在のキャラクター</Typography>
                <Grid container spacing={1} style={{marginTop:"0.25em"}}>
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>名前</FormLabel>
                            <div className={classes.formValue}>{states.name}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>趣味</FormLabel>
                            <div className={classes.formValue}>{states.hobby}</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>年齢</FormLabel>
                            <div className={classes.formValue}>{states.age}歳</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>身長</FormLabel>
                            <div className={classes.formValue}>{states.height}cm</div>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} style={{marginBottom:"5em"}}>
                        <FormControl fullWidth={true}>
                            <FormLabel className={classes.formLabel}>プロフィール</FormLabel>
                            <div className={classes.formValue}>{states.profile}</div>
                        </FormControl>
                    </Grid>
                </Grid>
                <div className={classes.modalBottom}>
                    <Button variant="outlined" color="primary" style={{width:"35%"}} onClick={edit}>変える</Button>
                    <Button variant="contained" color="primary" style={{width:"65%"}} onClick={send}>これで良い</Button>
                </div>
            </div>    
        )
    }

    return (
        <div id="confirm" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <Typography variant="subtitle1" className={classes.subtitle1}>キャラクター作成</Typography>
            <Grid container spacing={1} style={{marginTop:"0.25em"}}>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={errors.name!==""}>
                        <TextField
                            id="name"
                            label="名前（カタカナ3文字以内）"
                            value={states.name}
                            onChange={handleChange('name')}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />
                        {errors.name!=="" &&
                        <FormHelperText>{errors.name}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth={true} error={errors.hobby!==""}>
                        <TextField
                            id="hobby"
                            label="趣味（12文字以内）"
                            value={states.hobby}
                            onChange={handleChange('hobby')}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />                
                        {errors.hobby!=="" &&
                        <FormHelperText>{errors.hobby}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth={true} error={errors.age!==""}>
                        <TextField
                            id="age"
                            label="年齢（15～25）"
                            value={states.age}
                            onChange={handleChange('age')}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />                
                        {errors.age!=="" &&
                        <FormHelperText>{errors.age}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth={true} error={errors.height!==""}>
                        <TextField
                            id="height"
                            label="身長（140～180）"
                            value={states.height}
                            onChange={handleChange('height')}
                            margin="dense"
                            variant="outlined"
                            fullWidth
                        />                
                        {errors.height!=="" &&
                        <FormHelperText>{errors.height}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} style={{marginBottom:"5em"}}>
                    <FormControl fullWidth={true} error={errors.profile!==""}>
                        <TextField
                            id="profile"
                            label="プロフィール（60文字以内）"
                            value={states.profile}
                            onChange={handleChange('profile')}
                            margin="dense"
                            variant="outlined"
                            multiline
                            rows={6}
                            fullWidth
                        />                
                        {errors.profile!=="" &&
                        <FormHelperText>{errors.profile}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
            </Grid>

            <div className={classes.modalBottom}>
                <Button variant="outlined" color="primary" style={{width:"35%"}} onClick={auto}>自動生成</Button>
                <Button variant="contained" color="primary" style={{width:"65%"}} onClick={validate}>良い</Button>
            </div>
            <Loading isLoading={isLoading}/>
            <Toast close={closeToast} mes={toast}/>
        </div>
    );
}

export default Create;
